import { Page } from 'components';
import { useContext } from 'react';
import { adminUsersContext } from './AdminUsersContext';
import { Filters, Results } from './components';


let AdminUsers = () => {
    let { isLoading } = useContext(adminUsersContext);

    return (
        <Page
            useHeader={true}
            title="Admin Users"
            addNewUrl="/adminuser/addnew"
            isLoading={isLoading}
        >
            <Filters />
            <Results />
        </Page>
    )
}

export default AdminUsers;